module.exports = __webpack_public_path__ + "img/refresh.8ac73c52.svg";